module.exports = __webpack_public_path__ + "img/b2b_loan.82a493d5.png";